import React, { useEffect } from 'react'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'

export const SectorsSection = ({
  selectSectorFilter,
  articlesSelected,
  selectedSector,
}: {
  selectSectorFilter: (sectorId: number) => void
  articlesSelected: boolean
  selectedSector: number
}) => {
  const { sectors, loadSectors } = useArticleTemplate()
  useEffect(loadSectors, [loadSectors])

  return (
    <div className='flex flex-col gap-6 lg:gap-10'>
      <h3 className='font-bold text-lg md:text-2xl lg:text-[32px] text-[#001A3D]'>
        Sectors
      </h3>
      <ul>
        {sectors.map((sector, idx) => {
          const count = articlesSelected
            ? sector.article_count
            : sector.blog_count
          return (
            <li
              key={sector.name + idx}
              className={`flex justify-between bb-dotted py-4 
                        font-medium tracking-wide text-xs lg:text-base ${
                          count === 0
                            ? 'text-[#ccc]'
                            : selectedSector === sector.id
                            ? 'text-teal-500 underline'
                            : 'text-[#001A3D]'
                        }`}
            >
              <button
                onClick={() => selectSectorFilter(sector.id)}
                disabled={count === 0}
              >
                {sector.name}
              </button>
              <span>{count}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
